import * as Actions from "../Actions/FuncionalidadeTagActions";
import _ from "lodash";

const initialState = {
    //data      : [],

};

const FuncionalidadeTagReducer = function (state = initialState, action) {
    switch (action.type) {
        case Actions.GET_FUNCIONALIDADE_TAG:
            {
                if (_.isNull(action.name)) {
                    return { ...initialState };
                }

                return {
                    ...state,
                    [action.name]: action.payload && action.payload !== null ? action.payload : []
                };
            }
        case Actions.FUNCIONALIDADE_TAG_ERROR:
            {
                return {
                    ...state,
                    success: false,
                    error: action.payload
                };
            }
        case Actions.FUNCIONALIDADE_TAG_SELECIONAR_ERROR:
            {
                return {
                    ...state,
                    success: false,
                    error: action.payload
                };
            }
        default:
            {
                return state;
            }
    }
};

export default FuncionalidadeTagReducer;
